"use client";

import { useGetApiToken } from "@/util/api/swr";
import useLoading from "@/util/store/useLoading";
import useLoginStore from "@/util/store/useLoginStore";
import useUserStore from "@/util/store/user";
import { PersianNum } from "@/util/tools/PersianNum";
import { Heart } from "lucide-react";
import Link from "next/link";
import { useEffect, useMemo } from "react";

const FavoriteHeader = () => {
    const { token } = useUserStore();
    const { openLogin } = useLoginStore();
    const { loading, setLoading } = useLoading();

    const { data, isLoading, mutate } = useGetApiToken("/favorite-count", token);
    const count = data?.data?.count


    useEffect(() => {
        if (loading) {
            mutate();
            setLoading(false);
        }
    }, [loading, mutate, setLoading]);

    if (!token) {
        return (
            <div
                className="mx-1"
                role="button"
                onClick={openLogin}
            >
                <Heart aria-hidden="true" className="text-text1 size-6" />
            </div>
        );
    }

    return (
        <Link href="/profile/favorite" className="mx-1 relative">
            {!count ? null : isLoading ? (
                <span className="absolute top-[-4px] right-0 flex items-center justify-center h-5 w-5 border text-xs font-bold leading-none bg-pink transform translate-x-1/2 -translate-y-1/2 text-white rounded-full">
                    ...
                </span>
            ) : (
                <span className="absolute top-[-4px] right-0 flex items-center justify-center h-5 w-5 border text-xs font-bold leading-none bg-pink transform translate-x-1/2 -translate-y-1/2 text-white rounded-full">
                    {PersianNum(count)}
                </span>
            )}
            <Heart aria-hidden="true" className="text-text1 size-6" />
        </Link>
    );
};

export default FavoriteHeader;
